import axios from "axios";

//const
const EQUIPMENT_CERTIFY_VERIFY_UPDATE_DATA = "equipmentCertifyVerify/EQUIPMENT_CERTIFY_VERIFY_UPDATE_DATA";
const EQUIPMENT_CERTIFY_VERIFY_STORE_VERTIFY_CATEGORIES = "equipmentCertifyVerify/EQUIPMENT_CERTIFY_VERIFY_STORE_VERTIFY_CATEGORIES";
const EQUIPMENT_CERTIFY_VERIFY_STORE_EQUIPMENT_CERTIFIES = "equipmentCertifyVerify/EQUIPMENT_CERTIFY_VERIFY_STORE_EQUIPMENT_CERTIFIES";
const EQUIPMENT_CERTIFY_VERIFY_TOGGLE_MODAL = "equipmentCertifyVerify/EQUIPMENT_CERTIFY_VERIFY_TOGGLE_MODAL";
const EQUIPMENT_CERTIFY_VERIFY_TOGGLE_LOADING = "equipmentCertifyVerify/EQUIPMENT_CERTIFY_VERIFY_TOGGLE_LOADING";

//todo 中英文翻译
const EQUIPMENT_CERTIFY_VERIFY_MODAL_SUCCESS_TITLE = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_modal_success_title";
const EQUIPMENT_CERTIFY_VERIFY_MODAL_FAIL_TITLE = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_modal_fail_title";
const EQUIPMENT_CERTIFY_VERIFY_MODAL_VERIFY_SUCCESS_CONTENT = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_modal_verifySuccess_content";
const EQUIPMENT_CERTIFY_VERIFY_MODAL_VERIFY_FAIL_CONTENT = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_modal_verifyFail_content";
const EQUIPMENT_CERTIFY_VERIFY_MODAL_OK_LABEL = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_modal_OK_label";
const EQUIPMENT_CERTIFY_VERIFY_MODAL_CANCEL_LABEL = "scenes_Equipment_EquipmentCertifyManagement_EquipmentCertifyVerify_modal_cancel_label";

//reducer
export const equipmentCertifyVerify = (state = {
  loading: false,

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  equipmentCertifies: [],
  selectedKey: "",
  equipmentCertify: [],
  verifyCategories: [],
  verifyCategory: "",
  rangeDate: ["", ""],
  comment: "",
}, action) => {
  switch (action.type) {
    case EQUIPMENT_CERTIFY_VERIFY_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case EQUIPMENT_CERTIFY_VERIFY_STORE_VERTIFY_CATEGORIES:
      return {
        ...state,
        verifyCategories: action.data,
      };
    case EQUIPMENT_CERTIFY_VERIFY_STORE_EQUIPMENT_CERTIFIES:
      return {
        ...state,
        equipmentCertifies: action.data,
        selectedKey: "",
        equipmentCertify: [],
        comment: "",
      };
    case EQUIPMENT_CERTIFY_VERIFY_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case EQUIPMENT_CERTIFY_VERIFY_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based
 */
export const updateEquipmentCertifyVerifyData = (data) => {
  return {
    type: EQUIPMENT_CERTIFY_VERIFY_UPDATE_DATA,
    data: data
  }
};

/**
 * get all verify categories
 */
export const getVerifyCategories = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-equipment/getVerifyCategories`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeVerifyCategories(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store verify categories
 */
export const storeVerifyCategories = (verifyCategories) => {
  return {
    type: EQUIPMENT_CERTIFY_VERIFY_STORE_VERTIFY_CATEGORIES,
    data: verifyCategories
  }
};

/**
 * get equipment certifies
 */
export const getEquipmentCertifies = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-equipment/getEquipmentCertifyVerifyList?code=${data.verifyCategory}&name=&minDate=${data.rangeDate[0]}&maxDate=${data.rangeDate[1]}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeEquipmentCertifies(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all equipment certifies
 */
export const storeEquipmentCertifies = (equipmentCertifies) => {
  return {
    type: EQUIPMENT_CERTIFY_VERIFY_STORE_EQUIPMENT_CERTIFIES,
    data: equipmentCertifies
  }
};

/**
 * submit certify verify
 */

export const submitCertifyVerify = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "POST",
    url: "/api-equipment/submitCertifyVerify",
    contentType: "application/json",
    withCredentials: true,
    data: {
      "verifyCategory": data.certifyStatus === "1" ? "REGISTER" : "DESTROY",
      "certifyStatus": {code: data.certifyStatus === "1" ? data.isPass ? "2" : "3" : data.isPass ? "5" : "2"},
      "comment": data.comment,
      "reviewerId": data.reviewerId,
      "reviewerName": data.reviewerName,
      "equipmentCertify": {id: data.id}
    }
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200) {
        console.info("success submit certify verify");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: EQUIPMENT_CERTIFY_VERIFY_MODAL_SUCCESS_TITLE,
          modalContent: EQUIPMENT_CERTIFY_VERIFY_MODAL_VERIFY_SUCCESS_CONTENT,
          modalOk: EQUIPMENT_CERTIFY_VERIFY_MODAL_OK_LABEL,
          modalCancel: EQUIPMENT_CERTIFY_VERIFY_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(getEquipmentCertifies({
              verifyCategory: data.verifyCategory,
              rangeDate: data.rangeDate
            }));
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(getEquipmentCertifies({
              verifyCategory: data.verifyCategory,
              rangeDate: data.rangeDate
            }));
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      } else {
        console.error("fail to submit certify verify");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: EQUIPMENT_CERTIFY_VERIFY_MODAL_FAIL_TITLE,
          modalContent: EQUIPMENT_CERTIFY_VERIFY_MODAL_VERIFY_FAIL_CONTENT,
          modalOk: EQUIPMENT_CERTIFY_VERIFY_MODAL_OK_LABEL,
          modalCancel: EQUIPMENT_CERTIFY_VERIFY_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
    }
  );
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: EQUIPMENT_CERTIFY_VERIFY_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: EQUIPMENT_CERTIFY_VERIFY_TOGGLE_LOADING,
    data: show
  }
};

